import React from 'react';
import { observer, inject } from 'mobx-react';
import CellType from './CellType';
import * as Parse from '../../util/public/parseLayout';

@inject('globalStore', 'layoutStore')
@observer
export default class McLayout extends React.Component{
    render() {
        const { mcMark,globalStore,layoutStore } = this.props;
        const { JSComplete } = globalStore;
        const etables = layoutStore.dataJson.etables || {};
        const mcLayout = etables[mcMark];
        if(mcLayout == null)
            return <div style={{display: "none"}}>`Render ${mcMark} Exception`</div>
        const { rowcount,ec } = mcLayout;
        const ecMap = Parse.convertEcMap(ec);
        let mcCells = new Array();
        for(let r=0; r<rowcount; r++){
            const cellObj = ecMap[r+",0"];
            if(cellObj){
                const brObj = ecMap[r+",1"];
                const needBr = brObj && brObj.etype === "14" && brObj.brsign === "Y" && parseInt(cellObj.etype || 0) != 5;
                let className = `${mcMark}_${r}_0 span_mc etype_${cellObj.etype}`;
                const mcCellAttr = Parse.getMcCellAttr(cellObj);
                if(mcCellAttr.cusclass)
                    className += " "+mcCellAttr.cusclass;
                if(!needBr)
                    className += " span_mc_marginRight"
                const cellAttr = Parse.buildCellAttr(mcCellAttr, className, mcCellAttr.spanStyle);
                mcCells.push(<CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@pka2nh@${mcMark}_${r}`} 
                                symbol={mcMark}
                                cellAttr={cellAttr}
                                cellObj={cellObj}
                            />);
                needBr && mcCells.push(<br/>);
            }
        }
        return (
            <div>{mcCells}</div>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/McLayout.js